import React from "react";
import { connect } from "react-redux";
import Menu from "../menu";
import {
    Table,
    Pagination,
    Button,
    Input,
    Select,
    CheckBox,
    Icon,
    DatePicker,
} from "../../components";
import { axios, Constants, Globals, Format, ENV } from "../../utils";
import { Branch, Warehouse, Category, Brand } from "../../services";
import NumberFormat from "react-number-format";
import SearchIcon from '../../assets/icons/search.png';
import PrinterIcon from '../../assets/icons/printer.png';
import moment from "moment";


const HEADER = [
    "Código\nProducto",
    "Nombre\nProducto",
    "Fecha\nCompra",
    "Stock",
    "Cantidad\nVendida",
    "Precio\nCompra",
    "Precio\nVenta",
    "Ganancia",
];

class ProfitsPerProduct extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            last_page: 1,
            data: [],
            user: null,
            form: {
                search: "",
                user_id: this.props.user.id,
                w_stock: "",
            },
            user_id: this.props.user.id,
            role: this.props.user.role,
            dates: {
                minDate: "",
                maxDate: ""
            },
            sellers: [],
            list_stock: [
                { value: 1, label: "Con Stock" },
                { value: 0, label: "Sin Stock" }
            ],
        };
    }

    abortController = new AbortController();

    componentDidMount() {
        this.getSellers();
        this.load();
    }

    componentWillUnmount() {
        this.abortController.abort();
    }

    load = () => {
        this.getData();
    };

    getSellers = () => {
        let { form } = this.state;
        const { user } = this.props;

        axios
            .post("admin/reports/sellers-web", { user_id: user.id, only_sellers: true })
            .then(res => {
                this.setState({
                    sellers: res.data.sellers,
                    //data: [],
                });
            })
            .catch(err => {
                Globals.showError();
            });
    }

    getData = async (resetPage = null) => {
        let { page, form } = this.state;
        const { user } = this.props;

        if (typeof resetPage === "number") {
            page = resetPage;
        }

        Globals.setLoading();
        await axios
            .post("admin/reports/profitsPerProduct?page=" + page, form)
            .then(res => {
                this.setState({
                    last_page: res.data.products.last_page,
                    data: res.data.products.data,
                });
                Globals.quitLoading();
            })
            .catch(err => {
                Globals.showError();
            });
    };

    change = e => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    returnState = async () => {
        await this.setState(state => ({
            ...state,
            form: {
                search: "",
                user_id: this.props.user.id,
                w_stock: "",
            },
            page: 1,
        }));
        await this.load();
    };

    print = (data) => {
        let { form } = Globals.copy(this.state);
        form.download = true;

        axios
            .post("admin/reports/profitsPerProduct", form)
            .then(res => {
                if (res.data.url_storage) {
                    const url = `${ENV.BasePublic}${res.data.url_storage}`;
                    const win = window.open(url, "_blank");
                    win.focus();
                }
                else {
                    Globals.showError('Ha ocurrido un error');
                }
            })
            .catch(err => {
                Globals.showError();
            });

    };

    render() {

        return (
            <Menu history={this.props.history}>
                <div id="products" className="new-reports">
                    <div className="row">
                        <div className="col-md-3">
                            <Input
                                color=" "
                                name="search"
                                label="Búsqueda"
                                className="filter"
                                onChange={this.change}
                                value={this.state.form.search}
                                placeholder="Por nombre o código de producto"
                            />
                        </div>
                        <div className="col-md-2">
                            <Select
                                color="white"
                                name="w_stock"
                                label="Con Stock/Sin Stock"
                                defaultname="Todos"
                                disabledFirst="false"
                                className="filter"
                                style={{ textTransform: "capitalize" }}
                                onChange={emitter => this.change(emitter)}
                                value={this.state.form.w_stock}
                                options={this.state.list_stock}
                            />
                        </div>

                        <div className="col-md-2">
                            <DatePicker
                                color="white"
                                label="Desde"
                                className="filter"
                                minDate={this.state.dates.minDate}
                                value={this.state.form.since}
                                onChange={value => {
                                    this.setState(state => ({
                                        form: {
                                            ...state.form,
                                            since: value
                                        }
                                    }));
                                }}
                            />
                        </div>
                        <div className="col-md-2">
                            <DatePicker
                                color="white"
                                label="Hasta"
                                className="filter"
                                maxDate={this.state.dates.maxDate}
                                value={this.state.form.until}
                                onChange={value => {
                                    this.setState(state => ({
                                        form: {
                                            ...state.form,
                                            until: value
                                        }
                                    }));
                                }}
                            />
                        </div>

                        <div className="col-md-4">
                            <div className="container-buttons">
                                <Button 
                                    className="btn-align-bottom btn-filter blue" 
                                    color=" " 
                                    onClick={() => {
                                        this.setState({ page: 1 }, () => {
                                            this.getData();
                                        });
                                    }}
                                >
                                    <span>Filtrar</span>
                                </Button>
                                <Button className="btn-align-bottom btn-filter" color=" " onClick={this.returnState}>
                                    <span>Limpiar</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                    <Table
                        data={this.state.data.length}
                        title={'Reporte de ganancias por producto'}
                        header={HEADER}
                        right={
                            <Button
                                title="Imprimir"
                                small="true"
                                onClick={() => this.print(this.state.data)}
                            >
                                <img src={PrinterIcon} style={{ width: 24 }} alt="Imprimir" />
                            </Button>
                        }
                    >
                        {this.state.data.map((i, index) => {
                            return (
                                <tr
                                    key={index}
                                    style={i.main === 1 ? { fontWeight: 'bold', backgroundColor: '#f5f5f5' } : {}}
                                >
                                    <td style={{ maxWidth: 'none' }}>{i.product_code}</td>
                                    <td style={{ maxWidth: 'none' }}>{i.product_name}</td>
                                    <td style={{ maxWidth: 'none' }}>{i.date}</td>
                                    <td style={{ maxWidth: 'none' }}>{i.stock}</td>
                                    <td style={{ maxWidth: 'none' }}>{i.quantity_sold}</td>
                                    <td style={{ maxWidth: 'none' }}>{i.purchase_price}</td>
                                    <td style={{ maxWidth: 'none' }}>{i.sale_price}</td>
                                    <td style={{ maxWidth: 'none' }}>{i.profit}</td>
                                </tr>
                            );
                        })}
                    </Table>

                    <Pagination
                        pages={this.state.last_page}
                        active={this.state.page}
                        onChange={async page => {
                            await this.setState({
                                page: page
                            });
                            this.load();
                        }}
                    />

                </div>
            </Menu>
        );
    }
}

export default connect(state => {
    return {
        user: state.user
    };
})(ProfitsPerProduct);
